export var AnalyticsName = {
    PROFILE_CARD_CLICK: 'profile-card.click',
    PROFILE_CARD_VIEW: 'profile-card.view',
    PROFILE_CARD_LOADED: 'profile-card.loaded',
    PROFILE_CARD_RELOAD: 'profile-card.reload',
    PROFILE_CARD_ERROR: 'profile-card.error',
    PROFILE_CARD_RESOURCED_ERROR: 'profile-card-resourced.error',
};
//# sourceMappingURL=analytics.js.map